module.exports = __webpack_public_path__ + "img/Personal-icon.50736696.png";